export enum Locale {
  enUS = 'en-US', // English
  esUS = 'es-US', // Spanish
  myMM = 'my-MM', // Burmese
  htHT = 'ht-HT', // Haitian Creole
  zhTW = 'zh-TW', // Traditional Chinese
  viVN = 'vi-VN', // Vietnamese
  ilPH = 'il-PH', // Ilocano
  koUS = 'ko-US', // Korean
}

export type LanguageObject = {
  name: string;
  title: string;
  locale: Locale;
  code: string;
};

export type Languages = {
  [code: string]: LanguageObject;
};

export const LANGUAGES: Languages = {
  en: {
    name: 'English',
    title: 'English',
    locale: Locale.enUS,
    code: 'en',
  },
  es: {
    name: 'Spanish',
    title: 'Español',
    locale: Locale.esUS,
    code: 'es',
  },
  my: {
    name: 'Burmese',
    title: 'မြန်မာ',
    locale: Locale.myMM,
    code: 'my',
  },
  ht: {
    name: 'Haitian Creole',
    title: 'Kreyòl Ayisyen',
    locale: Locale.htHT,
    code: 'ht',
  },
  zh: {
    name: 'Traditional Chinese',
    title: '中文',
    locale: Locale.zhTW,
    code: 'zh',
  },
  vi: {
    name: 'Vietnamese',
    title: 'Tiếng Việt',
    locale: Locale.viVN,
    code: 'vi',
  },
  ic: {
    // lagoon and the transperfect are all use 'ic' for Ilocano
    name: 'Ilocano',
    title: 'Ilocano',
    locale: Locale.ilPH,
    code: 'ic',
  },
  ko: {
    name: 'Korean',
    title: '한국어',
    locale: Locale.koUS,
    code: 'ko',
  },
};

export const DefaultLanguage = LANGUAGES.en;
